import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircle';
import {
  Alert,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
  TextField,
  Box,
  IconButton,
  List,
  ListItem,
  Radio,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPlanChanged } from 'src/redux/counterSlice';
import type { RootState } from 'src/redux/store';
import {
  upgradePlanMessage,
  downgradePlanMessage,
  stripeStatusTrial,
  infoModalText,
  planNames,
  DesignerPlanText,
  pro,
  infoModalTexts,
  paths,
  expert,
  AgencyPlanText,
  FreePlanName,
  expertPlus,
  starter,
  proPlus
} from 'src/common/config/TextMessage';
import { useForm } from 'react-hook-form';
import {
  isAiAddonLocked,
  planButtonLabelText,
  getNormalizedPlan,
  localStorageMethod,
  normalizeName
} from 'src/common/config/FunctionHelper';
import { auditSite, getCreditDetails, validateCoupon, getSubscriptionDetailsStripe } from 'src/common/Scraper';
import CheckboxSiteList from './CheckBox';
import { useNavigate } from 'react-router';
import InfoIcon from '@mui/icons-material/Info';
import { UpgradeAgencyPlanModalSxs } from 'src/content/onBoarding/UpgradeAgencyPlanModalSx';
import { UpgradeAgencyModalTexts } from 'src/content/onBoarding/AllTexts';
import { AvatarGroupModule } from 'src/common/AvatarGroupsModule';
import CloseIcon from '@mui/icons-material/Close';
import useIsMobile from 'src/common/CheckDevice';
import { infoModalSxs } from './newChangePlan';
import { setIsPlanUpgradeStatus } from 'src/redux/siteAuditReducer';
import CommonModal from 'src/common/config/CommonModal';
import { DownGradeOfferModal } from './DownGradeOfferModal';
import { setStateStripeSubscription } from 'src/redux/userReducer';
import CommonAlert from 'src/common/CommonAlert';
import {
  hasLocalSeoCookie,
  removeLocalSeoCookie,
  updateSearchesDetailsAndLimits
} from 'src/common/config/FunctionHelperPartTwo';
import { CommonAlertModal } from 'src/common/CommonAlertModal';
import { useUserDetails } from 'src/hooks/apiHooks/useUserDetails';
import CouponSection from 'src/content/onBoarding/CouponSection';
import { planDescription } from './ChangePlan/utils/constants';

export default function InfoModal({
  handCloseModal,
  currentPlanId,
  allPlan,
  selectedPlanName,
  handleUpgradeDowngradePlan,
  changePlanSuccess,
  setChangePlanSuccess,
  loading,
  handleChangePlanModal,
  errorMessage,
  setErrorMessage
}) {
  const [auditSiteDetailes, setAuditSiteDetailes] = useState([]);
  const [selectedAuditUrls, setSelectedAuditUrls] = useState(auditSiteDetailes);
  const [remainingAuditUrls, setRemainingAuditUrls] = useState([]);
  const [auditSiteIds, setAuditSiteIds] = useState([]);
  const [isDropdownLoader, setIsDropdownLoader] = useState(false);
  const [activePlaneName, setActivePlanName] = useState(
    useSelector((state: RootState) => state.user.activePlan)
  );
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [isNoOptionSelected, setIsNoOptionSelected] = useState(null);
  const [otherReason, setOtherReason] = useState<string>(''); // State for 'Other' input
  const [missingFeature, setMissingFeature] = useState<string>(''); // State for 'Missing Features' input
  const [movingToOtherFeature, setMovingToOtherFeature] = useState<string>('');
  const [isOtherFieldError, setIsOtherFieldError] = useState(null);
  const [isMissingFieldError, setIsMissingFieldError] = useState(null); // State for 'Missing Features' input
  const [isMovingToOtherFieldError, setIsMovingToOtherFieldError] =
    useState(null);
  const { refetch: refetchUserDetails } = useUserDetails({ enabled: false });

  const planTrigger = useSelector(
    (state: RootState) => state.counter.planChanged
  );
  // Get plan is premium
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  const [downgradeBtnDisplay, setDowngradeBtnDisplay] = useState(true);
  const [selectedAuditIds, setSelectedAuditIds] = useState([]);
  const [openDowngradeOfferModal, setOpenDowngradeOfferModal] = useState(null);
  const [isMinCharOtherError, setIsMinCharOtherError] = useState(null);
  const [isMinCharMissingError, setIsMinCharMissingError] = useState(null);
  const [isMinCharMovingToOtherError, setIsMinCharMovingToOtherError] =
    useState(null);
  const [couponCode, setCouponCode] = useState('');
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [discountedPrice, setDiscountedPrice]: any = useState(null);
  const [creditDetails, setCreditDetails] = useState(null);
  const [creditDetailLoader, setCreditDetailLoader] = useState(false);
  const [selectedGmbIds, setSelectedGmbIds] = useState<string[]>([]);
  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      downgradeFeedback: ''
    }
  });
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  const isV1Plan = stripeSubscriptionDetails?.planVersion === 'v1';
  // const isV1Plan = stripeSubscriptionDetails?.planVersion === 'v1' || stripeSubscriptionDetails?.plan_name?.name === 'LocalSEO';
  let isNewPlan = useSelector((state: RootState) => state.user.isNewPlan) ?? {};
  const totalSlots = useSelector(
    (state: RootState) => state.userManagement.totalSlots
  );
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  let stripeData = useSelector((state: RootState) => state.user.stripeData);
  // Check if the site audit loader is active
  const loader =
    useSelector((state: RootState) => state.siteAudit.loader) ?? true;
  const isNotUnlocked = isAiAddonLocked();
  const isFreeAi =
    activePlaneName?.toUpperCase() == FreePlanName?.toUpperCase() &&
    !isNotUnlocked;
  const [isOfferApplied, setIsOfferApplied] = useState(
    userDetails?.isOfferApplied
  );

  const isFreeToPro =
    activePlaneName?.toUpperCase() == FreePlanName?.toUpperCase() &&
    selectedPlanName?.metadata?.display_name?.toUpperCase() !== 'FREE';
  const isFreePlan = activePlanName === planDetails.free;
  const isNoPlanAccount =
    !stripeLoader &&
    !loader &&
    userDetails?.email &&
    userDetails?.temp == true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);
  const isExpireAccount =
    !stripeLoader &&
    !loader &&
    !isFreePlan &&
    userDetails?.email &&
    userDetails?.temp !== true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);

  const isNoPlanOrExpire = isNoPlanAccount || isExpireAccount;
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const isLocalSeo = hasLocalSeoCookie();
  useEffect(() => {
    if (
      activePlaneName?.toUpperCase() === selectedPlanNameText?.toUpperCase() &&
      !isV1Plan
    ) {
      return;
    }
    setIsDropdownLoader(true);
    (async () => {
      setAudiSiteList();
      getSearchesDetail();
    })();
    return () => { };
  }, []);

  const getSearchesDetail = async () => {
    setCreditDetailLoader(true);
    const response: any = await getCreditDetails();
    if (response) {
      setCreditDetails(response);
      updateSearchesDetailsAndLimits(response);
    }
    setCreditDetailLoader(false);
  };


  useEffect(() => {
    if (selectedPlanName?.metadata?.display_name.toUpperCase() === 'FREE') {
      const filteredAuditSites = auditSiteIds?.map((site) => site._id);
      setRemainingAuditUrls(filteredAuditSites);
      setSelectedAuditIds(filteredAuditSites);
    }
  }, [auditSiteIds]);

  useEffect(() => {
    const filteredAuditDetails = auditSiteIds.filter(
      (detail) => !selectedAuditUrls.includes(detail.url)
    );
    const filteredSelectedAuditDetails = auditSiteIds.filter((detail) =>
      selectedAuditUrls.includes(detail.url)
    );
    const filteredAuditSites = filteredAuditDetails.map((site) => site._id);
    const filteredAuditSitesSelected = filteredSelectedAuditDetails.map(
      (site) => site._id
    );
    setRemainingAuditUrls(filteredAuditSites);
    setSelectedAuditIds(filteredAuditSitesSelected);
  }, [selectedAuditUrls]);

  // It handle deactive user state
  useEffect(() => {
  }, [watch('downgradeFeedback')]);

  const dispatch = useDispatch();
  useEffect(() => {
    allPlan.filter((data, index) => {
      if (data.id == currentPlanId) {
        setActivePlanName(data?.metadata?.display_name);
      }
    });
  }, []);

  useEffect(() => {
    setIsOfferApplied(userDetails?.isOfferApplied);
  }, [userDetails]);

  const getPlanShiftStatus = () => {
    if (isNewPlan == 'false') {
      return 'Upgrade';
    }
    let planName =
      selectedPlanName?.metadata?.display_name?.toLocaleLowerCase();
    let isMonth = selectedPlanName?.recurring?.interval;

    const normalizedActivePlan = getNormalizedPlan(activePlaneName, planDetails)?.toLowerCase();
    const normalizedSelectedPlan = getNormalizedPlan(planName, planDetails)?.toLowerCase();
    if (isV1Plan && normalizedActivePlan === normalizedSelectedPlan) {
      return 'Upgrade';
    }

    return planButtonLabelText(activePlaneName, planName, isMonth);
  };

  const getNotesTextDisplay = () => {
    if (
      (stripeSubscriptionDetails?.status === stripeStatusTrial ||
        stripeSubscriptionDetails?.allow_trial === true) &&
      selectedPlanName?.metadata?.display_name.toLowerCase() !==
      planDetails?.free
    ) {
      return infoModalText?.trialNote;
    } else if (
      (stripeSubscriptionDetails?.status === stripeStatusTrial ||
        stripeSubscriptionDetails?.allow_trial === true) &&
      selectedPlanName?.metadata?.display_name.toLowerCase() ===
      planDetails?.free
    ) {
      return '';
    } else {
      if (getPlanShiftStatus() === 'Downgrade') {
        return infoModalText?.downgradeNote;
      }
      if (getPlanShiftStatus() === 'Upgrade') {
        return infoModalText?.upgradeNote;
      }
    }
  };

  const setAudiSiteList = async () => {
    let auditSiteResponse: any = await auditSite();
    if (auditSiteResponse?.length) {
      const urls = auditSiteResponse?.map((site) => site.url);
      const siteIds = auditSiteResponse?.map((site) => ({
        _id: site._id,
        url: site.url
      }));
      setAuditSiteIds(siteIds);
      setAuditSiteDetailes(urls);
      setTimeout(() => {
        setIsDropdownLoader(false);
        if (
          selectedPlanName?.metadata?.display_name.toUpperCase() !== 'FREE' ||
          isFreeAi
        ) {
          setDowngradeBtnDisplay(true);
        }
      }, 1000);
    } else {
      setAuditSiteDetailes([]);
      setTimeout(() => {
        setIsDropdownLoader(false);
        if (
          selectedPlanName?.metadata?.display_name.toUpperCase() !== 'FREE' ||
          isFreeAi
        ) {
          setDowngradeBtnDisplay(true);
        }
      }, 1000);
    }
  };

  /**
   * Handle the selection of audit URLs.
   * @param {array} urls - Selected audit URLs.
   */
  const selectedValues = (urls) => {
    setSelectedAuditUrls(urls);
  };

  // It handle deactive user state
  useEffect(() => {
    if (changePlanSuccess) {
      localStorageMethod('set', 'purchase_success', 'true');
      setTimeout(async () => {
        try {
          const subDetails = await getSubscriptionDetailsStripe();
          dispatch(setStateStripeSubscription(subDetails));
        } catch (e) {
          console.error('Error updating stripe subscription after plan change:', e);
          dispatch(setStateStripeSubscription(stripeData));
        }

        if (!isFreeToPro) {
          dispatch(
            setIsPlanUpgradeStatus({
              open: true,
              status: getPlanShiftStatus()
            })
          );
        }

        handCloseModal();
        handleChangePlanModal();
        setChangePlanSuccess(false);
        dispatch(setPlanChanged(!planTrigger));
        
        await refetchUserDetails();

        if (isLocalSeo || hasLocalSeoCookie()) {
          removeLocalSeoCookie();
        }

        navigate(
          selectedPlanName?.metadata?.display_name.toUpperCase() !== 'FREE'
            ? paths?.dashboard
            : paths?.externalScans
        );
      }, 5000);
    }
  }, [changePlanSuccess]);

  const planFeatureList: any = {
    free: [
      'Scan Live Squarespace Web Pages',
      'Squarespace SEO Community and Tutorials'
    ],
    diy: [
      'Automatic site-wide SEO audit',
      'Spy on competitors',
      'Blog post suggestions'
    ],
    starter: [
      'Automatic site-wide SEO audit',
      'Spy on competitors',
      'Blog post suggestions'
    ],
    starterplus: [
      'Automatic site-wide SEO audit',
      'Spy on competitors',
      'Blog post suggestions'
    ],
    starterPlus: [
      'Automatic site-wide SEO audit',
      'Spy on competitors',
      'Blog post suggestions'
    ],
    'starter plus': [
      'Automatic site-wide SEO audit',
      'Spy on competitors',
      'Blog post suggestions'
    ],
    designer: [
      'Audit up to 3 sites',
      '200 keyword research credits',
      'Scan draft and password-protected Squarespace web pages'
    ],
    proplus: [
      'Audit up to 5 sites',
      '200 keyword research credits',
      'Scan draft and password-protected Squarespace web pages'
    ],
    proPlus: [
      'Audit up to 5 sites',
      '200 keyword research credits',
      'Scan draft and password-protected Squarespace web pages'
    ],
    'pro plus': [
      'Audit up to 5 sites',
      '200 keyword research credits',
      'Scan draft and password-protected Squarespace web pages'
    ],
    agency: [
      'Audit up to 10 sites',
      '500 keyword research credits',
      '1-on-1 onboarding call'
    ],
    expertplus: [
      'Audit up to 20 sites',
      '500 keyword research credits',
      '1-on-1 onboarding call'
    ],
    'expert plus': [
      'Audit up to 20 sites',
      '500 keyword research credits',
      '1-on-1 onboarding call'
    ],
  };

  const selectedPlanNameText = selectedPlanName?.metadata?.display_name || '';
  const timeline = selectedPlanName?.recurring?.interval;
  const selectedPlanNameFiltered =
    selectedPlanNameText?.toLowerCase() == 'designer'
      ? 'Pro'
      : selectedPlanNameText?.toLowerCase() == 'pro plus' || selectedPlanNameText?.toLowerCase() == 'proplus'
        ? 'Pro'
      : selectedPlanNameText?.toLowerCase() == 'agency' || selectedPlanNameText?.toLowerCase() == 'expert'
        ? expert
        : selectedPlanNameText?.toLowerCase() == 'expert plus'
          ? expert
        : selectedPlanNameText?.toLowerCase() == 'starter plus'
          ? starter
          : selectedPlanNameText;
  const upgradeDowngradeTitle =
    getPlanShiftStatus() + ' to ' + selectedPlanNameFiltered;
  const selectedTimeLine =
    selectedPlanName?.recurring?.interval == 'month' ? 'Monthly' : 'Annually';

  const handleErrorSnackBarClose = () => {
    setErrorMessage(null);
  };
  const scansCount = selectedPlanName?.metadata?.scan;
    // selectedPlanName?.metadata?.display_name.toUpperCase() ===
    //   planNames.designer.toUpperCase()
    //   ? totalCalculation
    //   :
  const limitValue = auditSiteDetailes?.length - scansCount;
  const remainingCheck =
    Number(remainingAuditUrls?.length || 0) > Number(scansCount || 0);
  const checkSiteLimit =
    ((getPlanShiftStatus() === 'Downgrade' &&
      selectedPlanNameFiltered !== 'Free') ||
      isFreeAi ||
      (isV1Plan && selectedPlanNameFiltered !== 'Free')) &&
    (remainingCheck || isDropdownLoader);
  const planGmbLimit = selectedPlanName?.gmb_limit !== undefined && selectedPlanName?.gmb_limit !== null
    ? parseInt(selectedPlanName?.gmb_limit, 10)
    : 0;
  const addonGmbLimit = creditDetails?.totalGmbAddonLimit
    ? parseInt(creditDetails?.totalGmbAddonLimit, 10)
    : 0;
  const allowedGmbCount = planGmbLimit + addonGmbLimit;
  const activeBusinesses = creditDetails?.businesses || [];
  const gmbLimitValue = activeBusinesses.length - allowedGmbCount;
  const remainingGmbLocationIds = activeBusinesses
    .filter((b) => !selectedGmbIds.includes(b.GMB_location_id))
    .map((b) => b.GMB_location_id);
  const remainingGmbCheck = remainingGmbLocationIds.length > allowedGmbCount;
  const checkGmbLimit =
    ((getPlanShiftStatus() === 'Downgrade' && selectedPlanNameFiltered !== 'Free') ||
      (isV1Plan && selectedPlanNameFiltered !== 'Free')) &&
    selectedPlanName?.gmb_limit !== undefined &&
    selectedPlanName?.gmb_limit !== null &&
    (remainingGmbCheck || creditDetailLoader);
  const freePlanWarningAlert =
    getPlanShiftStatus() === 'Downgrade' &&
    selectedPlanNameFiltered == 'Free' &&
    auditSiteDetailes?.length > 0;
  const freePlanDisableBtn =
    getPlanShiftStatus() === 'Downgrade' &&
    selectedPlanNameFiltered == 'Free' &&
    isDropdownLoader;

  const isFreeDowngrade =
    getPlanShiftStatus() === 'Downgrade' &&
    !isFreePlan &&
    selectedPlanNameFiltered == 'Free';

  let freeDowngradeOptions;
  const selectedTimeLineForDowngrade =
    stripeSubscriptionDetails?.interval == 'month' ? 'Monthly' : 'Annually';
  // const isSchedule =
  //   Object.keys(stripeSubscriptionDetails || {})?.length !== 0 &&
  //   stripeSubscriptionDetails?.schedule;
  if (isOfferApplied || isNoPlanOrExpire) {
    freeDowngradeOptions = [
      'Hiring someone to do it for me instead',
      'Missing Features',
      'Other'
    ];
  } else {
    freeDowngradeOptions = [
      // ...(selectedTimeLineForDowngrade === 'Annually'
      //   ? ['Prefer Monthly Billing']
      //   : []),
      'Too expensive',
      ...(selectedTimeLineForDowngrade !== 'Annually'
        ? ['Not using the tool as much for now']
        : []),
      //'Finding hard to use',
      'Facing bugs',
      'Hiring someone to do it for me instead',
      'Moving to another tool',
      'Missing Features',
      'Other'
    ];
  }

  const handleToggle = (option: string) => {
    setSelectedOption((prev) => {
      const newSelection = prev === option ? null : option;
      if (isNoOptionSelected) {
        setIsNoOptionSelected(newSelection === null); // If no option is selected, set it to true
      }
      // Reset text input when deselecting
      if (newSelection !== 'Other') {
        setOtherReason('');
        setIsOtherFieldError(false);
        setIsMinCharOtherError(false);
      }
      if (newSelection !== 'Missing Features') {
        setMissingFeature('');
        setIsMissingFieldError(false);
        setIsMinCharMissingError(false);
      }
      if (newSelection !== 'Moving to another tool') {
        setMovingToOtherFeature('');
        setIsMovingToOtherFieldError(false);
        setIsMinCharMovingToOtherError(false);
      }
      return newSelection;
    });
  };

  const handleContinueDowngradeToFree = () => {
    if (!selectedOption) {
      setIsNoOptionSelected(true);
      return;
    }
    if (selectedOption == 'Other' && otherReason?.length == 0) {
      setIsOtherFieldError(true);
      return;
    }
    if (selectedOption == 'Missing Features' && missingFeature?.length == 0) {
      setIsMissingFieldError(true);
      return;
    }
    if (
      selectedOption == 'Moving to another tool' &&
      movingToOtherFeature?.length == 0
    ) {
      setIsMovingToOtherFieldError(true);
      return;
    }
    if (selectedOption == 'Other' && otherReason?.length < 30) {
      setIsMinCharOtherError(true);
      return;
    }
    if (selectedOption == 'Missing Features' && missingFeature?.length < 30) {
      setIsMinCharMissingError(true);
      return;
    }
    if (
      selectedOption == 'Moving to another tool' &&
      movingToOtherFeature?.length < 30
    ) {
      setIsMinCharMovingToOtherError(true);
      return;
    }
    if (
      selectedOption == 'Other' ||
      selectedOption == 'Missing Features' ||
      selectedOption == 'Moving to another tool'
    ) {
      handleDowngrade();
      return;
    }
    setIsMinCharOtherError(false);
    setIsMinCharMissingError(false);
    setIsNoOptionSelected(false);
    setIsOtherFieldError(false);
    setIsMissingFieldError(false);
    setOpenDowngradeOfferModal(true);
    //handCloseModal();
  };

  const handleChangeOtherReason = (e) => {
    setOtherReason(e.target.value);
    if (e.target.value?.length > 0) {
      setIsOtherFieldError(false);
    }
  };
  const handleChangeMissingFeatureReason = (e) => {
    setMissingFeature(e.target.value);
    if (e.target.value?.length > 0) {
      setIsMissingFieldError(false);
    }
  };
  const handleChangeMovingToOtherFeatureReason = (e) => {
    setMovingToOtherFeature(e.target.value);
    if (e.target.value?.length > 0) {
      setIsMovingToOtherFieldError(false);
    }
  };

  const handleCloseDownGradeOfferModal = () => {
    setOpenDowngradeOfferModal(null);
  };

  const handleDowngrade = () => {
    const planChangeText = getPlanShiftStatus();
    const planChangeStatus =
      isV1Plan &&
        selectedPlanName?.metadata?.version === 'v2' &&
        selectedPlanName?.metadata?.display_name?.toUpperCase() !== 'FREE'
        ? 'Upgrade'
        : planChangeText;
    const userFeedback =
      selectedOption == 'Moving to another tool'
        ? movingToOtherFeature
        : selectedOption == 'Other'
          ? otherReason
          : selectedOption == 'Missing Features'
            ? missingFeature
            : watch('downgradeFeedback');

    handleUpgradeDowngradePlan(
      selectedPlanName.id,
      planChangeStatus,
      userFeedback,
      //Old code
      //remainingAuditUrls
      selectedAuditIds,
      selectedOption,
      appliedCoupon,
      selectedGmbIds
    );
  };

  const validateAndApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError('Please enter a coupon code');
      return;
    }
    setCouponLoading(true);
    setCouponError('');
    try {
      const payload = {
        couponId: couponCode?.trim(),
        planId: selectedPlanName?.id,
        isAnnual: selectedPlanName?.subTitle == 'Annually' ? true : false
      };
      const response: any = await validateCoupon(payload);
      if (response?.status === 'success') {
        const result = response?.data;
        setAppliedCoupon(result?.coupon || couponCode?.trim());
        setDiscountedPrice(result);
        setCouponError('');
      } else {
        setCouponError(response?.message || 'Invalid coupon code');
        setAppliedCoupon(null);
        setDiscountedPrice(null);
      }
    } catch (error) {
      setCouponError('Failed to validate coupon. Please try again.');
      setAppliedCoupon(null);
      setDiscountedPrice(null);
    } finally {
      setCouponLoading(false);
    }
  };

  const removeCoupon = () => {
    setCouponCode('');
    setAppliedCoupon(null);
    setDiscountedPrice(null);
    setCouponError('');
  };

  return (
    <>
      <Backdrop
        sx={{ color: 'var(--color-white)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading && !openDowngradeOfferModal}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {isFreeDowngrade ? (
        <Box sx={infoModalSxs?.freeDowngradeMainBox}>
          <Box sx={infoModalSxs?.freeDowngradeHeadBox}>
            <Typography sx={infoModalSxs?.freeDowngradeTitle}>
              {isLocalSeo
                ? selectedPlanNameFiltered
                : activePlaneName?.toUpperCase() ==
                  selectedPlanNameText?.toUpperCase()
                  ? `Switch to ${selectedPlanNameFiltered} ${selectedTimeLine}`
                  : upgradeDowngradeTitle}
            </Typography>
            <IconButton
              aria-label="close"
              className="hover:rounded-lg"
              sx={infoModalSxs?.iconBtn}
              onClick={handCloseModal}
            >
              <CloseIcon sx={{ color: 'var(--color-text-sidebar-icon) !important' }} />
            </IconButton>
          </Box>
          <Typography sx={infoModalSxs?.freeDowngradeDesc}>
            {infoModalTexts?.freeDowngradeDesc}
          </Typography>
          {selectedPlanNameText === 'Free' && (
            <CommonAlert
              severity="warning"
              message={infoModalTexts?.freeDowngradeNote}
              sx={{ marginTop: '8px' }}
            />
          )}
          <Box>
            <List>
              {freeDowngradeOptions.map((option) => {
                const isSelected = selectedOption === option;
                return (
                  <ListItem
                    key={option}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                      paddingTop: '0px',
                      flexDirection: 'column',
                      gap: '0px'
                    }}
                    onClick={() => handleToggle(option)}
                  >
                    {/* Text Box */}
                    <Box
                      sx={{
                        border: `1px solid ${isSelected ? 'var(--color-secondary)' : 'var(--color-border-medium)'
                          }`,
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <Radio
                        checked={isSelected}
                        sx={{
                          color: isSelected ? 'var(--color-secondary)' : 'var(--color-border)',
                          '&.Mui-checked': { color: 'var(--color-secondary)' },
                          '&:hover': {
                            backgroundColor: 'transparent' // Removes hover effect
                          }
                        }}
                        disableRipple
                      />
                      <Typography
                        sx={{
                          fontFamily: 'Inter',
                          fontWeight: 400,
                          fontSize: 'var(--font-size-14)',
                          lineHeight: 'var(--line-height-20)',
                          color: 'var(--color-primary)'
                        }}
                      >
                        {option}
                      </Typography>
                    </Box>
                    {/* Show TextField for "Other" or "Missing Features" */}
                    {(selectedOption === 'Other' ||
                      selectedOption === 'Missing Features' ||
                      selectedOption === 'Moving to another tool') &&
                      selectedOption === option && (
                        <TextField
                          fullWidth
                          multiline
                          variant="outlined"
                          sx={{
                            mt: 1,
                            '& .MuiInputBase-root': {
                              borderRadius: '6px',
                              //maxHeight: '42px'
                              paddingTop: '14px',
                              paddingBottom: '14px'
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor:
                                isOtherFieldError ||
                                  isMissingFieldError ||
                                  isMovingToOtherFieldError
                                  ? 'var(--color-error-dark)'
                                  : 'var(--color-text-secondary)'
                            }
                          }}
                          InputProps={{
                            style: { ...infoModalSxs?.placeHolderText } // Sets placeholder font size
                          }}
                          placeholder={
                            selectedOption === 'Moving to another tool'
                              ? "Tell us why you're downgrading to help us improve SEOSpace"
                              : selectedOption === 'Other'
                                ? "Tell us why you're downgrading to help us improve SEOSpace"
                                : 'Help us improve SEOSpace by sharing which features we’re missing'
                          }
                          value={
                            selectedOption === 'Moving to another tool'
                              ? movingToOtherFeature
                              : selectedOption === 'Other'
                                ? otherReason
                                : missingFeature
                          }
                          onChange={(e) => {
                            const inputValue = e.target.value.slice(0, 200); // Auto-trims input to 200 chars
                            if (inputValue.length <= 200) {
                              if (selectedOption === 'Moving to another tool') {
                                handleChangeMovingToOtherFeatureReason({
                                  target: { value: inputValue }
                                });
                              } else if (selectedOption === 'Other') {
                                handleChangeOtherReason({
                                  target: { value: inputValue }
                                });
                              } else {
                                handleChangeMissingFeatureReason({
                                  target: { value: inputValue }
                                });
                              }
                            }
                          }}
                          error={
                            (selectedOption === 'Moving to another tool' &&
                              movingToOtherFeature?.length >= 200) ||
                            (selectedOption === 'Other' &&
                              otherReason?.length >= 200) ||
                            (selectedOption !== 'Moving to another tool' &&
                              selectedOption !== 'Other' &&
                              missingFeature?.length >= 200)
                          }
                          helperText={
                            (selectedOption === 'Moving to another tool' &&
                              movingToOtherFeature?.length >= 200) ||
                              (selectedOption === 'Other' &&
                                otherReason?.length >= 200) ||
                              (selectedOption !== 'Moving to another tool' &&
                                selectedOption !== 'Other' &&
                                missingFeature?.length >= 200)
                              ? 'You have reached the maximum limit of 200 characters.'
                              : ''
                          }
                          onClick={(e) => e.stopPropagation()} // Prevents ListItem click event
                          autoComplete="off" // Turns off autocomplete
                        />
                      )}
                    {(selectedOption === 'Other' ||
                      selectedOption === 'Missing Features' ||
                      selectedOption === 'Moving to another tool') &&
                      selectedOption === option &&
                      (isOtherFieldError ||
                        isMissingFieldError ||
                        isMinCharMissingError ||
                        isMinCharOtherError ||
                        isMovingToOtherFieldError ||
                        isMinCharMovingToOtherError) && (
                        <Box sx={infoModalSxs?.noSelectionFieldErrorBox}>
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              `/static/images/icons/red-info-dark.svg`
                            }
                            alt="Icon"
                            style={infoModalSxs?.imgBoxSx}
                          />
                          <Typography sx={infoModalSxs?.noSelectionError}>
                            {isMinCharMissingError ||
                              isMinCharOtherError ||
                              isMinCharMovingToOtherError
                              ? infoModalTexts?.charError
                              : isMovingToOtherFieldError
                                ? infoModalTexts?.otherReasonError
                                : isOtherFieldError
                                  ? infoModalTexts?.otherReasonError
                                  : infoModalTexts?.missingFeatureError}
                          </Typography>
                        </Box>
                      )}
                  </ListItem>
                );
              })}
            </List>
          </Box>
          {isNoOptionSelected && (
            <Box sx={infoModalSxs?.noSelectionErrorBox}>
              <img
                src={
                  process.env.PUBLIC_URL +
                  `/static/images/icons/red-info-dark.svg`
                }
                alt="Icon"
                style={infoModalSxs?.imgBoxSx}
              />
              <Typography sx={infoModalSxs?.noSelectionError}>
                {infoModalTexts?.noSelectionError}
              </Typography>
            </Box>
          )}
          {changePlanSuccess ? (
            <Alert
              icon={
                <CheckCircleOutlineIcon
                  fontSize="inherit"
                  sx={{ color: 'var(--color-secondary)' }}
                />
              }
              severity="success"
              className="mb-1 mt-1"
            >
              {getPlanShiftStatus() === 'Downgrade' && downgradePlanMessage}
              {getPlanShiftStatus() === 'Upgrade' && upgradePlanMessage}
            </Alert>
          ) : (
            ''
          )}
          <CommonAlertModal
            status={errorMessage && !openDowngradeOfferModal ? 'error' : null}
            message={
              <>
                {errorMessage?.isCardError
                  ? UpgradeAgencyModalTexts?.cardError
                  : errorMessage?.message}
                {errorMessage?.isCardError && <br />}

                {errorMessage?.isCardError && (
                  <span
                    onClick={() => {
                      handleErrorSnackBarClose();
                      handCloseModal();
                      handleChangePlanModal();
                    }}
                    style={infoModalSxs?.changePayment}
                  >
                    {UpgradeAgencyModalTexts?.changePaymentMethod}
                  </span>
                )}
              </>
            }
            onClose={handleErrorSnackBarClose}
          />
          <Box sx={infoModalSxs?.freeDowngradeBtnBox}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                handCloseModal();
                // When click to continue improve seo score
                handleChangePlanModal();
              }}
              sx={infoModalSxs?.freeDowngradeStayBtn}
            >
              <Typography
                sx={{ ...infoModalSxs?.stayOnBtnText, color: 'var(--color-white)' }}
              >
                {infoModalTexts?.stayWith}
                {activePlaneName.toUpperCase() ===
                  DesignerPlanText?.toUpperCase() || activePlaneName.toUpperCase() ===
                    proPlus?.toUpperCase()
                  ? ` ${pro} `
                  : activePlaneName.toUpperCase() ===
                    AgencyPlanText?.toUpperCase()
                    ? ` ${expert} `
                    : activePlaneName.toUpperCase() ===
                      expertPlus?.toUpperCase()
                      ? ` ${expert} `
                      : ` ${activePlaneName} `}
              </Typography>
            </Button>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => {
                handleContinueDowngradeToFree();
              }}
              sx={infoModalSxs?.freeDowngradeStayBtn}
            >
              <Typography
                sx={{ ...infoModalSxs?.stayOnBtnText, color: 'var(--color-primary)' }}
              >
                {infoModalTexts?.continue}
              </Typography>
            </Button>
          </Box>
        </Box>
      ) : (
        <Box sx={UpgradeAgencyPlanModalSxs?.mainContainerSx}>
          <Box
            sx={{
              width: { xs: '100%', ms: '60%' },
              ...UpgradeAgencyPlanModalSxs?.firstContainerSx
            }}
          >
            <Box sx={UpgradeAgencyPlanModalSxs?.titleBoxSx}>
              <Typography sx={UpgradeAgencyPlanModalSxs?.titleSx}>
                {isLocalSeo
                  ? selectedPlanNameFiltered
                  : activePlaneName?.toUpperCase() ==
                    selectedPlanNameText?.toUpperCase()
                    ? `Switch to ${selectedPlanNameFiltered} ${selectedTimeLine}`
                    : upgradeDowngradeTitle}
              </Typography>
              {isMobile && (
                <IconButton
                  onClick={handCloseModal}
                  disableRipple
                  aria-label="close"
                  sx={UpgradeAgencyPlanModalSxs?.iconBtnSx}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Box>
            <Typography
              sx={{
                ...UpgradeAgencyPlanModalSxs?.descSx,
                marginTop: '2px'
              }}
            >
              {planDescription[normalizeName(selectedPlanNameText)]}
            </Typography>
            <Box sx={infoModalSxs?.billingBox}>
              <Box
                className="mb-3"
                sx={infoModalSxs?.priceBoxSx}
              >
                <Box>
                  <Typography
                    sx={UpgradeAgencyPlanModalSxs?.timelineBoxTitleSx}
                  >
                    {timeline === 'year'
                      ? infoModalTexts?.billedAnnually
                      : infoModalTexts?.billedMonthly}
                  </Typography>
                  <Box sx={UpgradeAgencyPlanModalSxs?.typoBoxSx}>
                    <Typography
                      className="mt-2"
                      sx={UpgradeAgencyPlanModalSxs?.timelineBoxTextSx}
                    >
                      {appliedCoupon ? (
                        <>
                          <span style={UpgradeAgencyPlanModalSxs?.spanAmountSx}>
                            {`$${(
                              (selectedPlanName?.unit_amount / 100) *
                              (1 - (discountedPrice?.savings?.percentage || 25) / 100)
                            ).toFixed(2)}`}
                          </span>
                          <span
                            style={{
                              marginLeft: '8px',
                              fontSize: 'var(--font-size-20)',
                              fontWeight: '500',
                              textDecoration: 'line-through',
                              opacity: '0.5'
                            }}
                          >
                            {`$${(selectedPlanName?.unit_amount / 100)?.toFixed(2)}`}
                          </span>
                        </>
                      ) : (
                        <span style={UpgradeAgencyPlanModalSxs?.spanAmountSx}>
                          {`$${(selectedPlanName?.unit_amount / 100)?.toFixed(
                              selectedPlanNameText === 'Free' ? 0 : 2
                            )}`}
                        </span>
                      )}
                      {timeline === 'year' ? '/yr' : '/month'}{' '}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            {((getPlanShiftStatus() === 'Downgrade' &&
              selectedPlanName?.metadata?.display_name.toUpperCase() !==
              'FREE') ||
              isFreeAi ||
              (isV1Plan &&
                selectedPlanName?.metadata?.display_name.toUpperCase() !==
                'FREE')) && (
                <div>
                  {(isDropdownLoader || creditDetailLoader) && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100px' // Set the height of the container
                      }}
                    >
                      <CircularProgress size={34} />
                    </div>
                  )}
                </div>
              )}
            {((getPlanShiftStatus() === 'Downgrade' &&
              selectedPlanName?.metadata?.display_name.toUpperCase() !==
              planNames.free.toUpperCase() &&
              activePlaneName?.toUpperCase() !==
              selectedPlanNameText?.toUpperCase()) ||
              isFreeAi ||
              (isV1Plan &&
                selectedPlanName?.metadata?.display_name.toUpperCase() !==
                planNames.free.toUpperCase())) &&
              auditSiteDetailes?.length >
              selectedPlanName?.metadata?.scan && (
                <Box
                  sx={{
                    ...infoModalSxs?.checkBoxMainBox,
                    backgroundColor: isDropdownLoader || creditDetailLoader ? '' : 'var(--color-bg-muted-alt)'
                  }}
                >
                  {isDropdownLoader || creditDetailLoader ? (
                    <div></div>
                  ) : (
                    <>
                      <Typography sx={infoModalSxs?.checkBoxNoteText}>
                        {isFreeAi
                          ? `Note: To upgrade to the ${selectedPlanNameFiltered} plan, you need to reduce your site usage to match the plan limits. The ${selectedPlanNameFiltered} plan allows ${scansCount} site slot${scansCount > 1 ? 's' : ''
                          }, but your account currently has ${auditSiteDetailes?.length
                          } sites. Please remove ${limitValue} site${limitValue > 1 ? 's' : ''
                          } before upgrading. Removing a site will also remove its associated AI slots.`
                          : isV1Plan ? `Note: Your plan will be ${getPlanShiftStatus().toLowerCase()}d immediately to ${selectedPlanNameFiltered} plan. This means you will lose ${limitValue} site slot${limitValue > 1 ? 's' : ''} and have ${scansCount} on your new plan. Please select ${limitValue} site${limitValue > 1 ? 's' : ''} to be removed from your account when your plan is ${getPlanShiftStatus().toLowerCase()}d.`
                            : `Note: At the end of this billing cycle you will be downgraded to ${selectedPlanNameFiltered} plan. This means you will lose ${limitValue} site slots and have ${scansCount} on your new plan. Please select ${limitValue} sites to be removed from your account when your plan is downgraded.`}
                      </Typography>
                      <CheckboxSiteList
                        data={auditSiteDetailes}
                        selectedValues={selectedValues}
                        isInfo={true}
                        scans={selectedPlanName?.metadata?.scan}
                      />
                    </>
                  )}
                </Box>
              )}
            {((getPlanShiftStatus() === 'Downgrade' &&
              activePlaneName?.toUpperCase() !==
              selectedPlanNameText?.toUpperCase()) ||
              (isV1Plan &&
                selectedPlanName?.metadata?.display_name.toUpperCase() !==
                planNames.free.toUpperCase())) &&
              selectedPlanName?.gmb_limit !== undefined &&
              selectedPlanName?.gmb_limit !== null &&
              activeBusinesses.length > allowedGmbCount && (
                <Box
                  sx={{
                    ...infoModalSxs?.checkBoxMainBox,
                    backgroundColor: isDropdownLoader || creditDetailLoader ? '' : 'var(--color-bg-muted-alt)',
                    marginTop: '16px'
                  }}
                >
                  {isDropdownLoader || creditDetailLoader ? (
                    <div></div>
                  ) : (
                    <>
                      <Typography sx={infoModalSxs?.checkBoxNoteText}>
                        {
                          isV1Plan
                            ? `Note: Your plan will be ${getPlanShiftStatus().toLowerCase()}d immediately to ${selectedPlanNameFiltered}. This means you will lose ${gmbLimitValue} Google Business slot${gmbLimitValue > 1 ? 's' : ''
                            }, and the selected Google Business location${gmbLimitValue > 1 ? 's will' : ' will'
                            } be removed instantly from your account. You will have ${allowedGmbCount} Google Business slot${allowedGmbCount > 1 ? 's' : ''
                            } available on your new plan.`
                            : `Note: At the end of this billing cycle you will be downgraded to ${selectedPlanNameFiltered} plan. This means you will lose ${gmbLimitValue} Google Business slot${gmbLimitValue > 1 ? 's' : ''
                            } and have ${allowedGmbCount} on your new plan. Please select ${gmbLimitValue} Google Business location${gmbLimitValue > 1 ? 's' : ''
                            } to be removed from your account when your plan is downgraded.`
                        }
                      </Typography>
                      <Paper
                        style={{
                          maxHeight: activeBusinesses.length > 50 ? 150 : 'auto',
                          overflowX: 'hidden',
                          height: '107px',
                          overflowY: 'auto',
                          boxShadow: 'none',
                          scrollbarWidth: 'thin',
                          scrollbarColor: 'lightgray transparent',
                          backgroundColor: 'var(--color-bg-muted-alt)',
                          borderRadius: '0px'
                        }}
                      >
                        <List>
                          <FormGroup>
                            {activeBusinesses.map((biz, index) => {
                              const isChecked = selectedGmbIds.includes(biz.GMB_location_id);
                              const isDisable = !isChecked && selectedGmbIds.length >= gmbLimitValue;
                              return (
                                <FormControlLabel
                                  key={index}
                                  control={
                                    <Checkbox
                                      size="small"
                                      disabled={isDisable}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedGmbIds([...selectedGmbIds, biz.GMB_location_id]);
                                        } else {
                                          setSelectedGmbIds(selectedGmbIds.filter(id => id !== biz.GMB_location_id));
                                        }
                                      }}
                                      checked={isChecked}
                                      sx={{
                                        paddingTop: '4px',
                                        paddingBottom: '4px',
                                        '& .MuiSvgIcon-root': {
                                          fontSize: '1rem'
                                        },
                                        '&:hover': { backgroundColor: 'transparent' }
                                      }}
                                      disableRipple
                                    />
                                  }
                                  label={
                                    <Typography
                                      sx={{
                                        fontFamily: 'Inter',
                                        fontSize: '12px',
                                        fontWeight: '400 !important',
                                        lineHeight: 'var(--line-height-16)',
                                        color: 'var(--color-primary)',
                                        letterSpacing: '0.3px'
                                      }}
                                    >
                                      {biz.location_name}
                                    </Typography>
                                  }
                                />
                              );
                            })}
                          </FormGroup>
                        </List>
                      </Paper>
                    </>
                  )}
                </Box>
              )}
            {freePlanWarningAlert && !isDropdownLoader && (
              <Typography sx={infoModalSxs?.downgradeFreeSiteTextSx}>
                {infoModalTexts?.downgradeFreeSiteText}
              </Typography>
            )}
            {changePlanSuccess ? (
              <Alert
                icon={
                  <CheckCircleOutlineIcon
                    fontSize="inherit"
                    sx={{ color: 'var(--color-secondary)' }}
                  />
                }
                severity="success"
                className="mb-1 mt-1"
              >
                {getPlanShiftStatus() === 'Downgrade' && downgradePlanMessage}
                {getPlanShiftStatus() === 'Upgrade' && upgradePlanMessage}
              </Alert>
            ) : (
              ''
            )}
            <CommonAlertModal
              status={errorMessage ? 'error' : null}
              message={
                <>
                  {errorMessage?.isCardError
                    ? UpgradeAgencyModalTexts?.cardError
                    : errorMessage?.message}
                  {errorMessage?.isCardError && <br />}

                  {errorMessage?.isCardError && (
                    <span
                      onClick={() => {
                        handleErrorSnackBarClose();
                        handCloseModal();
                        handleChangePlanModal();
                      }}
                      style={infoModalSxs?.changePayment}
                    >
                      {UpgradeAgencyModalTexts?.changePaymentMethod}
                    </span>
                  )}
                </>
              }
              onClose={handleErrorSnackBarClose}
            />
            {(isDropdownLoader || creditDetailLoader) &&
              getPlanShiftStatus() === 'Downgrade' &&
              selectedPlanName?.metadata?.display_name.toUpperCase() ==
              'FREE' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50px' // Set the height of the container
                  }}
                >
                  <CircularProgress size={34} />
                </div>
              )}

            {isV1Plan && (
              <Box sx={{ marginTop: '16px' }}>
                <CouponSection
                  couponCode={couponCode}
                  setCouponCode={setCouponCode}
                  couponError={couponError}
                  couponLoading={couponLoading}
                  appliedCoupon={appliedCoupon}
                  discountedPrice={discountedPrice}
                  validateAndApplyCoupon={validateAndApplyCoupon}
                  removeCoupon={removeCoupon}
                  isAnnual={selectedPlanName?.recurring?.interval === 'year'}
                  isButtonDisabled={changePlanSuccess}
                />
              </Box>
            )}

            <Button
              fullWidth
              variant="contained"
              disabled={
                (checkSiteLimit &&
                  (activePlaneName?.toUpperCase() !==
                  selectedPlanNameText?.toUpperCase() || isV1Plan)) ||
                (checkGmbLimit &&
                  (activePlaneName?.toUpperCase() !==
                  selectedPlanNameText?.toUpperCase() || isV1Plan)) ||
                freePlanDisableBtn ||
                (getPlanShiftStatus() === 'Downgrade'
                  ? !downgradeBtnDisplay
                  : loading) || changePlanSuccess
              }
              onClick={() => {
                const planChangeText = getPlanShiftStatus();
                const planChangeStatus =
                  isV1Plan &&
                    selectedPlanName?.metadata?.version === 'v2' &&
                    selectedPlanName?.metadata?.display_name?.toUpperCase() !== 'FREE'
                    ? 'Upgrade'
                    : planChangeText;
                const userFeedback = watch('downgradeFeedback');
                handleUpgradeDowngradePlan(
                  selectedPlanName.id,
                  planChangeStatus,
                  userFeedback,
                  //Old code
                  //remainingAuditUrls
                  selectedAuditIds,
                  undefined,
                  appliedCoupon,
                  selectedGmbIds
                );
              }}
              sx={infoModalSxs?.btnSx}
            >
              {isLocalSeo
                ? UpgradeAgencyModalTexts?.purchaseText
                : activePlaneName?.toUpperCase() ==
                  selectedPlanNameText?.toUpperCase()
                  ? `Switch to ${selectedPlanNameFiltered} ${selectedTimeLine}`
                  : getPlanShiftStatus() === 'Downgrade'
                    ? UpgradeAgencyModalTexts?.downgradeText
                    : UpgradeAgencyModalTexts?.upgradeText}
            </Button>

            <Box className="flex-col my-3 space-y-3 mb-0">
              {/* Display info alert */}
              {getNotesTextDisplay() && (
                <>
                  <Box sx={infoModalSxs?.infoIconBoxSx}>
                    <InfoIcon style={infoModalSxs?.infoIconSx} />
                    <Typography sx={infoModalSxs?.noteTextSx}>
                      {getNotesTextDisplay()}
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          </Box>
          <Box sx={UpgradeAgencyPlanModalSxs?.secondContainerSx}>
            <Box sx={UpgradeAgencyPlanModalSxs?.joiBoxSx}>
              <Typography sx={UpgradeAgencyPlanModalSxs?.joiDescSx}>
                {UpgradeAgencyModalTexts?.joinDesc}
              </Typography>
              {!isMobile && (
                <IconButton
                  onClick={handCloseModal}
                  disableRipple
                  aria-label="close"
                  sx={UpgradeAgencyPlanModalSxs?.iconBtnSx}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Box>
            <Box sx={UpgradeAgencyPlanModalSxs?.avatarGroupBoxSx}>
              <AvatarGroupModule />
            </Box>
            <Box sx={infoModalSxs?.listBoxSx}>
              <Typography sx={UpgradeAgencyPlanModalSxs?.listTitleSx}>
                {`Why ${isLocalSeo
                  ? `${UpgradeAgencyModalTexts?.choose} ${
                    selectedPlanNameText?.toLowerCase() == 'designer' ||
                    selectedPlanNameText?.toLowerCase() == 'pro' ||
                    selectedPlanNameText?.toLowerCase() == 'proplus' ||
                    selectedPlanNameText?.toLowerCase() == 'pro plus'
                      ? 'Pro'
                      : selectedPlanNameText?.toLowerCase() == 'agency' ||
                        selectedPlanNameText?.toLowerCase() == 'expert' ||
                        selectedPlanNameText?.toLowerCase() == 'expert plus'
                        ? expert
                        : selectedPlanNameText
                  }`
                  : getPlanShiftStatus() === 'Downgrade'
                    ? ` stay on ${
                      activePlaneName?.toLowerCase() == 'designer' ||
                      activePlaneName?.toLowerCase() == 'pro' ||
                      activePlaneName?.toLowerCase() == 'proplus' ||
                      activePlaneName?.toLowerCase() == 'pro plus'
                        ? 'Pro'
                        : activePlaneName?.toLowerCase() == 'agency' ||
                          activePlaneName?.toLowerCase() == 'expert' ||
                          activePlaneName?.toLowerCase() == 'expert plus'
                          ? expert
                          : activePlaneName?.toLowerCase() == 'starter plus'
                            ? starter
                            : activePlaneName
                    }`
                    : `${getPlanShiftStatus()} to ${
                      selectedPlanNameText?.toLowerCase() == 'designer' ||
                      selectedPlanNameText?.toLowerCase() == 'proplus' ||
                      selectedPlanNameText?.toLowerCase() == 'pro plus'
                        ? 'Pro'
                        : selectedPlanNameText?.toLowerCase() == 'agency' ||
                          selectedPlanNameText?.toLowerCase() == 'expert' ||
                          selectedPlanNameText?.toLowerCase() == 'expert plus'
                        ? expert
                        : selectedPlanNameText?.toLowerCase() == 'starter plus'
                        ? starter
                        : selectedPlanNameText
                    }`
                  }?`}
              </Typography>
              <Box sx={UpgradeAgencyPlanModalSxs?.listSubBoxSx}>
                {planFeatureList[
                  getPlanShiftStatus() === 'Downgrade'
                    ? activePlaneName?.toLowerCase()
                    : selectedPlanNameText?.toLowerCase()
                ]?.map((feature, index) => (
                  <Box
                    key={index}
                    sx={UpgradeAgencyPlanModalSxs?.listFeatureBoxSx}
                  >
                    <img
                      draggable={false}
                      src={
                        process.env.PUBLIC_URL +
                        `/static/images/icons/check-icon-blue.svg`
                      }
                      alt="Check Icon"
                    />
                    <Typography
                      sx={UpgradeAgencyPlanModalSxs?.listFeatureTextSx}
                    >
                      {feature}
                    </Typography>
                  </Box>
                ))}
                <Box sx={infoModalSxs?.learnMoreBoxSx}>
                  <Typography sx={UpgradeAgencyPlanModalSxs?.listFeatureTextSx}>
                    {infoModalTexts?.muchMore}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <CommonModal
        open={openDowngradeOfferModal}
        handCloseModal={handleCloseDownGradeOfferModal}
        title=""
        closebtn={false}
        blur={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
        isDownGradeOfferModal={true}
      >
        <DownGradeOfferModal
          handleCloseDownGradeOfferModal={handleCloseDownGradeOfferModal}
          selectedPlanName={selectedPlanName}
          handleDowngrade={handleDowngrade}
          selectedOption={selectedOption}
          otherReason={otherReason}
          missingFeature={missingFeature}
          loading={loading}
          handleErrorSnackBarClose={handleErrorSnackBarClose}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
          errorMessage={errorMessage}
          changePlanSuccess={changePlanSuccess}
          selectedTimeLine={selectedTimeLineForDowngrade}
        />
      </CommonModal>
    </>
  );
}
